<template>
  <div class="fullheight">
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="container">
        <div class="navbar-brand">
          <a class="navbar-item" style="padding-top: 10px;">
            <img src="../../src/assets/img/cardiff-white-text-only.png" id="logo" height="28" alt="cardiff logo"/>
          </a>
        </div>
      </div>
    </nav>
    <div class="fullheight" id="appcontainer">
      <div class="columns fullheight is-centered">
        <div class="column" id="app-column">
          <transition :name="transition" mode="out-in">
            <DocLoading v-if="layout == 'Loading'" key="p0" :loading="loading" />
            <BLA v-if="layout == 'bla'" key="BLA" :model="model" />
            <BLA v-if="layout == 'oppbla'" key="OPPBLA" :model="model" />
            <Report v-if="layout == 'report' || layout=='appreport'" key="Report" :report="model" hidebuttons="true" />
            <Statements v-if="layout == 'statements'" key="Statements" :month="this.$route.params.month" :account="this.$route.params.account" :model="model" />
          </transition>
        </div>
      </div>
    </div>
    <!-- <footer class="footer" style="margin-top: 60px;" v-if="page != 7">
      <div class="content has-text-centered">
          <p style="font-size: 0.675em; color: grey; margin-top: 10px;">© 2019 Commercial Finance & Leasing Bank of Cardiff, Inc</p>
      </div>
    </footer>-->
  </div>
</template>

<script>
import { DocLoading, BLA, Statements } from "@/components/docs";
import { Report } from "@/components/aggregation";
import $ from "jquery";
export default {
  name: "GenerateDoc",
  components: {
    DocLoading,
    BLA,
    Report,
    Statements
  },
  data() {
    return {
      transition: "slide",
      layout: "Loading",
      model: { business: { name: "test" } },
      loading: true
    };
  },
  methods: {
    incrementPage: function(pageData) {
      this.transition = "slide";
      this.validate();
      this.page++;
      window.scrollTo(0, 0);
    },

    decrementPage: function(pageData, amount = 1) {
      this.transition = "slideb";
      this.page -= amount;
      window.scrollTo(0, 0);
    },
    validate: function() {
      console.log(this.$route.params.code);
      let self = this
      $.ajax({
        type: "POST",
        url: "/api/doc/get-data",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({ doc: this.$route.params.doc, id: this.$route.params.id, token: this.$route.params.token })
      })
        .done(function(response) {
          self.model = response.model
          self.layout = self.$route.params.doc;
        })
        .fail(function(err) {
          
          console.log(err.responseText);
          console.log("invalid link!");
          self.invalid = true;
          self.loading = false
        });
    }
  },
  mounted: function() {
    let self = this;
    setTimeout(function() {
      self.validate();
    }, 0);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
  background-color: #3c5cac;
  z-index: 2;
}
.navbar .navbar-brand {
  text-align: center;
  display: block;
  width: 100%;
}

.navbar .navbar-brand > .navbar-item,
.navbar .navbar-brand .navbar-link {
  display: inline-block;
}
@media screen and (min-width: 767px), print {
  .mobile-only {
    display: none;
  }
  .fullheight {
    /* height: 100%; */
  }
  #app-column {
    padding: 50px 50px;
  }
}

@media screen and (max-width: 768px) {
  #cardiff-column {
    display: none;
  }
  #app-column {
    min-height: 100vh;
    padding-top: 50px;
  }
}

#cardiff-column {
  background: #f1f1f1;
  z-index: 1;
  padding-top: 100px;
  max-width: 280px;
}

#logo {
  /* max-width: 50%; */
  margin: auto;
  display: block;
  /* margin-top: 10px; */
  /* margin-bottom: 10px; */
}

.next-button {
  margin-top: 10px;
}

.columns {
  margin-left: 0;
  margin-right: 0;
}

.no-margin {
  margin-bottom: 0px !important;
}
</style>
